import React, { useEffect, useState } from 'react';
import { Button, Grid, IconButton } from '@mui/material';
import ImageIcon from '@mui/icons-material/Image';
import DeleteIcon from '@mui/icons-material/Delete';
import imageCompression from 'browser-image-compression';

const ImageUpload = ({base64Image,setBase64Image}) => {
  const [selectedImage, setSelectedImage] = useState(null);
  
  useEffect(()=>{
    if(base64Image!='')
    {
        setSelectedImage(`data:image/jpeg;base64,${base64Image}`); 
    }
    else setSelectedImage(null)
    
  },[base64Image])

  const handleImageChange = async (event) => {
    const file = event.target.files[0]; 
    if(file.size>20*1048576)
    {
        alert('Oversized Image. Max Image Size Allowed: 20MB')
        return
    }
    if (file) {
      try {
        // Compress the image
        const options = {
          maxSizeMB: 1,
          maxWidthOrHeight: 200,
          useWebWorker: true
        };
        const compressedFile = await imageCompression(file, options);
        

        // Convert the compressed file to base64 string
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64String = reader.result;
         
          
          setBase64Image(base64String.split(',')[1]); // Extracting the base64 part
        };
        reader.readAsDataURL(compressedFile);
      } catch (error) {
        console.error('Error compressing the image:', error);
        // alert('Error uploading image')
      }
    }
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
  };

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item>
        <input
          type="file"
          accept="image/*"
          style={{ display: 'none' }}
          id="upload-image"
          onChange={handleImageChange}
        />
        <label htmlFor="upload-image">
          <Button
            variant="contained"
            component="span"
            startIcon={<ImageIcon />}
          >
            Upload Image
          </Button>
        </label>
      </Grid>
      {selectedImage && (
        <>
          <Grid item>
            <img
              src={selectedImage}
              alt="Selected"
              style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '8px' }}
            />
          </Grid>
          <Grid item>
            <IconButton aria-label="delete" onClick={handleRemoveImage} color="error">
              <DeleteIcon />
            </IconButton>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default ImageUpload;
